<template>
  <div
    class="with-loader__wrapper"
    :class="{
      ['isLoading']: isLoading,
      [horizontalPosition]: true,
      [verticalPosition]: true,
      [extraClass]: true,
      ['full-height']: fullHeight,
    }"
  >
    <div v-if="isLoading" class="with-loader__inner">
      <svg
        version="1.1"
        id="L9"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 100 100"
        enable-background="new 0 0 0 0"
        xml:space="preserve"
      >
        <path
          :fill="color"
          d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
        >
          <animateTransform
            attributeName="transform"
            attributeType="XML"
            type="rotate"
            dur="1s"
            from="0 50 50"
            to="360 50 50"
            repeatCount="indefinite"
          ></animateTransform>
        </path>
      </svg>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import VLoaderEnvelope from "@/components/VLoaderEnvelope";
import variables from "@/styles/_variables.scss";

export default Vue.component("WithLoader", {
  props: {
    isLoading: VueTypes.bool.def(false),
    classType: VueTypes.oneOf(["primary", "secondary", "tertiary", "dark"]).def(
      "primary"
    ),

    horizontalPosition: VueTypes.oneOf(["center", "left", "right"]).def(
      "center"
    ),
    verticalPosition: VueTypes.oneOf(["center", "top", "bottom"]).def("center"),
    extraClass: VueTypes.string.def(""),
    fullHeight: VueTypes.bool.def(false)
  },

  computed: {
    color() {
      return variables[this.classType];
    }
  },

  components: {
    VLoaderEnvelope
  }
});
</script>

<style lang="scss" scoped>
$ns: "with-loader";
.#{$ns} {
  &__wrapper {
    height: 100%;

    &.isLoading {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      &.left {
        justify-content: flex-start;
      }

      &.right {
        justify-content: flex-end;
      }

      &.top {
        align-items: flex-start;
      }

      &.bottom {
        align-items: flex-end;
      }
    }

    &.full-height {
      min-height: 100vh;
    }
  }

  &__inner {
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 70px;
      height: 70px;
    }
  }
}
</style>
